import { token } from '@atlaskit/tokens';

export const primaryTextColour: 'var(--ds-text)' = token('color.text');
